






































import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class DeleteLinkPopup extends Vue {
  @Prop() popupId!: string
  @Prop() link!: any
  @Prop() brandId!: number

  public busy = false

  deleteLink () {
    if (!this.link || !this.link.id) return
    this.busy = true
    this.$store.dispatch('deleteLink', { brandId: this.brandId, linkId: this.link.id }).then(() => {
      this.$emit('deleted')
      const btn = this.$refs.popupCloseButton as HTMLElement
      if (btn) btn.click()
      this.$notify({ type: 'success', text: 'Link deleted successfully' })
      this.busy = false
    }, () => {
      this.busy = false
      this.$notify({ type: 'error', text: 'Failed to delete link' })
      const btn = this.$refs.popupCloseButton as HTMLElement
      if (btn) btn.click()
    })
  }
}
